import {
	FaqListBlockElementModelContentType,
	SearchResultsBlockElementModelContentType,
} from "#/_generated/umbraco/delivery-api/models";

export default class ElementTypes {
	static SearchResultsBlock =
		SearchResultsBlockElementModelContentType.searchResultsBlock;
	static FaqListBlock = FaqListBlockElementModelContentType.faqListBlock;
}
